<style lang="scss" scoped>
/deep/ .comp-maintenance-performance-dialog {
    max-width: 400px;
}
</style>

<template>
    <div class="comp-maintenance-performance">
        <el-dialog :title="title" custom-class="c-el-dialog comp-maintenance-performance-dialog" 
        :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false" append-to-body>
            <el-form :model="dialogData" :rules="formRules" :ref="formRefName" label-width="80px" size="small">
                <el-col :xs="24">
                    <el-form-item label="绩效">
                        <el-radio-group v-model="dialogData.performance">
                            <el-radio-button v-for="item in performances" :label="item" :key="item"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item ref="refRemark" label="备注" prop="auditMessage">
                        <el-input type="textarea" :rows="5" v-model="dialogData.auditMessage" placeholder="请设置备注"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="_close()">取消</el-button>
                <el-button size="small" type="primary" @click="_save()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as funEmployees from '@/api/employees'
export default {
    name: "compMaintenancePerformance",
    data() {
        return {
            title: "",
            showDialog: false,
            dialogData: {
                id: "",
                performance: 0,
                auditMessage: ""
            },
            performances: [0, 0.5, 1, 1.5, 2],
            formRefName: "refMaintenancePerformance",
            formRules: {
                auditMessage: []
            }
        }
    },
    watch: {
        "dialogData.performance"(v) {
            if (v == 1) {
                this.formRules.auditMessage = []
            } else {
                this.formRules.auditMessage = [{ required: true, message: '请设置备注', trigger: ['blur', 'change']}]
            }
            this.$refs["refRemark"] && this.$refs["refRemark"].clearValidate("auditMessage")
        }
    },
    methods: {
        open(item) {
            this.title = `${item.name}【${item.date}】的绩效`
            this.dialogData = JSON.parse(JSON.stringify(item))
            if (!item.audited) {
                this.dialogData.performance = 1
            }
            this.showDialog = true
        },
        _save() {
            this.$refs[this.formRefName].validate(valid => {
                if (valid) {
                    let submitData = {
                        id: this.dialogData.id,
                        performance: this.dialogData.performance,
                        remark: this.dialogData.auditMessage
                    }
                    funEmployees.AuditDayWork(submitData).then(res => {
                        this.commonSuccess("操作成功!")
                    })
                }
            })
        },
        _close() {
            this.showDialog = false
            this.$nextTick(() => {
                if (this.$refs[this.formRefName]) {
                    this.$refs[this.formRefName].resetFields()
                }
            })
        },
        commonSuccess(val) {
            let tips = val || "操作成功!"
            this.alert(tips).then(() => {
                this._close()
                window.$common.closeFullLoading()
                this.refreshData()
            })
        },
        refreshData() {
            this.$emit("refreshData", true)
        }
    }
}
</script>